/**
 * CalqTool Analytics - Eigen analytics (Google Analytics-achtig)
 * Stuurt events naar onze API, geen externe diensten.
 * Alleen na expliciete cookie-opt-in (zie cookie-consent).
 */

import { hasAnalyticsConsent } from './cookie-consent';
import { getStoredLastTenantId } from './api';

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '/api';

function getSessionId(): string {
  if (typeof window === 'undefined') return '';
  let s = sessionStorage.getItem('calqtool_session');
  if (!s) {
    s = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
    sessionStorage.setItem('calqtool_session', s);
  }
  return s;
}

export async function trackEvent(
  name: string,
  params?: Record<string, string | number>
): Promise<void> {
  if (typeof window === 'undefined') return;
  if (!hasAnalyticsConsent()) return;

  const path = (params?.page_path as string) ?? window.location.pathname + window.location.search;
  const payload = {
    event_type: name,
    path,
    referrer: document.referrer || undefined,
    session_id: getSessionId(),
    tenant_id: getStoredLastTenantId() ?? 'default',
  };

  try {
    await fetch(`${API_BASE.replace(/\/$/, '')}/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // Stil falen - analytics mag de UX niet blokkeren
  }

  if (import.meta.env.DEV) {
    console.debug('[Analytics]', name, params);
  }
}

export function trackPageView(path: string, title?: string) {
  trackEvent('page_view', { page_path: path, page_title: title ?? path });
}

export function trackProjectCreated(projectId: string) {
  trackEvent('project_created', { project_id: projectId });
}

export function trackOfferteGenerated(projectId: string) {
  trackEvent('offerte_generated', { project_id: projectId });
}
